import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {TriggerUtils} from "@/modules/redactor/models/trigger/core/TriggerUtils";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";

export class SmartOfferBundleNoviceBattlePassDayQuest extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SmartOfferBundleNoviceBattlePassDayQuest, v) : SKIP;
            },
            (v) => {
                return deserialize(SmartOfferBundleNoviceBattlePassDayQuest, v) || new SmartOfferBundleNoviceBattlePassDayQuest();
            }
        );
    }

    constructor() {
        super();
        this._key = null;
        this._name = null;
        this._reward = null;
        this._guard = new GuardConfig();
        this._triggersComplete = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get triggersComplete() {
        return this._triggersComplete;
    }

    set triggersComplete(value) {
        this._triggersComplete = value;
    }

    valid() {

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.triggersComplete.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.triggersComplete.length != 1) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleNoviceBattlePassDayQuest());
        } else if (target instanceof SmartOfferBundleNoviceBattlePassDayQuest) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleNoviceBattlePassDayQuest, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _reward: alias("reward", RewardModel.schema()),
    _triggersComplete: alias("triggers_complete", TriggerUtils.schema())
});